import _ from 'lodash';
import EnterpriseService from 'web-core/src/enterprise-service';
import { Tracking } from 'web-core/src/tracking';
import type { CreateLoginArgs, ProvisionArgs } from 'web-core/types/enterprise/user';
import { fetchUser, receiveUserData } from 'client/actions/user';

export function fetchConfiguration() {
  return (dispatch, getState, { apiClient }) => {
    const enterpriseService = new EnterpriseService({ client: apiClient });
    return enterpriseService.fetchConfiguration().then((response) => {
      dispatch(receiveUserData(response));
      return response;
    });
  };
}

export function createAndProvision(payload: CreateLoginArgs) {
  return (dispatch, getState, { apiClient }) => {
    const enterpriseService = new EnterpriseService({ client: apiClient });
    return enterpriseService
      .createAndProvision(payload)
      .then((response) => {
        if (response.status === 'ERROR') {
          return Promise.reject(response);
        }
        dispatch(receiveUserData(response.data.user));
        Tracking.registerUser(response.data.user);
        // TODO: update user property in redux store based off response instead of making another fetch
        dispatch(fetchConfiguration());
        return response;
      })
      .catch((err) => {
        const errorCode = _.get(err, 'response.status');
        // If issue with the code, still want to refresh user state
        if (errorCode === 422) {
          return Promise.all([
            dispatch(fetchUser()).then(() => Tracking.registerUser(getState().user)),
            dispatch(fetchConfiguration()),
          ]).then(() => Promise.reject(err));
        }
        return Promise.reject(err);
      });
  };
}

export function loginAndProvision(payload: CreateLoginArgs) {
  return (dispatch, getState, { apiClient }) => {
    const enterpriseService = new EnterpriseService({ client: apiClient });
    return enterpriseService
      .loginAndProvision(payload)
      .then((response) => {
        if (response.status === 'ERROR') {
          return Promise.reject(response);
        }
        dispatch(receiveUserData(response.data.user));
        dispatch(fetchConfiguration());
        return response;
      })
      .catch((err) => {
        const errorCode = _.get(err, 'response.status');
        // If issue with the code, still want to refresh user state
        if (errorCode === 422) {
          return Promise.all([dispatch(fetchUser()), dispatch(fetchConfiguration())]).then(() =>
            Promise.reject(err));
        }
        return Promise.reject(err);
      });
  };
}

export function provision(payload: ProvisionArgs) {
  return (dispatch, getState, { apiClient }) => {
    const enterpriseService = new EnterpriseService({ client: apiClient });
    return enterpriseService.provision(payload).then((response) => {
      dispatch(receiveUserData(response.data.user));
      dispatch(fetchConfiguration());
      return response;
    });
  };
}
